// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"63c10272","148":"b5cc50ed","195":"71719663","253":"b54cc88a","317":"44075e08","336":"f408f540","385":"277b7730","479":"5115047d","503":"edf6e7c6","549":"47422e96","576":"17924651","620":"d0cfb327","709":"e55672a2","736":"0c21b477","752":"27735fbc","992":"bbf5b24c"}[chunkId] + ".chunk.js";
};